import script from "./WarehouseShipmentDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./WarehouseShipmentDetail.vue?vue&type=script&setup=true&lang=js"

import "./WarehouseShipmentDetail.vue?vue&type=style&index=0&id=8f2a085c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f2a085c"]])

export default __exports__